module.exports = __webpack_public_path__ + "media/images/icons/flags/AX-d3ba47d9f53142dfd9e02c76fb61b2bf.svg";